import React from "react";
import Skeleton from "react-loading-skeleton";

function LastOfferSkeleton() {
  return (
    <div className="flex gap-5 min-w-[80%]">
      <Skeleton
        containerClassName="rounded-[2rem]  w-[350]"
        height={400}
        className="normal-radius   mx-auto"
        width={300}
      />
      <Skeleton
        containerClassName=" rounded-[2rem]  w-[350]"
        height={400}
        className="normal-radius   mx-auto"
        width={300}
      />
      <Skeleton
        containerClassName=" rounded-[2rem]  w-[350]"
        height={400}
        className="normal-radius   mx-auto"
        width={300}
      />
      <Skeleton
        containerClassName=" rounded-[2rem]  w-[350]"
        height={400}
        className="normal-radius   mx-auto"
        width={300}
      />
    </div>
  );
}

export default LastOfferSkeleton;
